// extracted by mini-css-extract-plugin
export var divider = "_om-0";
export var systemMessage = "_om-1";